import { SimpleNft } from "logic/types/nft/INft";
import { equalIgnoreCase } from "./equalIgnoreCase";

export function areTheSameNft(nft1: SimpleNft, nft2: SimpleNft): boolean {
  return (
    equalIgnoreCase(nft1.collection, nft2.collection) &&
    nft1.tokenId === nft2.tokenId
  );
}
